import { h, Fragment, createElement } from 'preact'
import classnames from 'classnames'

export function Button(props) {

	const { 
		href, 
		variant = 'fill',
		size = 'medium',
		iconLeft,
		iconRight,
		block,
		separator,
		class: className, 
		children,
		as = 'button',
		...attributes 
	} = props

	const variants = Array.isArray(variant) ? variant : variant.split(' ')

	const classes = classnames(
		'ui-button',
		`ui-button--${size}`,
		className,
		block && 'ui-button--block',
		variants.length && variants.map(variant => `ui-button--${variant}`),
		separator && 'ui-button--separator',
	)

	const attrs = { 
		class: classes, 
		href, 
		as,
		...attributes 
	}

	return <LinkWrap {...attrs}>
		{iconLeft && <span class="ui-button__icon ui-button__icon--left"><Any value={iconLeft} /></span>}
		{iconLeft && separator && <span class="ui-button__separator"></span>}
		{children && <span class="ui-button__label">{children}</span>}
		{iconRight && separator && <span class="ui-button__separator"></span>}
		{iconRight && <span class="ui-button__icon ui-button__icon--right"><Any value={iconRight} /></span>}
	</LinkWrap>
}

export function IconButton(props) {

	const { 
		href, 
		variant = 'fill',
		size = 'medium',
		icon,
		class: className, 
		as = 'button',
		...attributes 
	} = props

	const variants = Array.isArray(variant) ? variant : variant.split(' ')

	const classes = classnames(
		'ui-button ui-button--icon',
		variants.length && variants.map(variant => `ui-button--${variant}`),
		`ui-button--${size}`,
		className,
	)

	const attrs = { 
		class: classes, 
		href,
		as,
		 ...attributes
	}

	return <LinkWrap {...attrs}>
		{icon && <span class="ui-button__icon"><Any value={icon} /></span>}
	</LinkWrap>
}

export default Button

function Any({ value: Value }) {
	if (typeof Value === 'string') return <>{Value}</>
	return <Value />
}

function LinkWrap(props) {
	const { 
		children, 
		as = Fragment,
		...attributes 
	} = props

	return (props.href !== undefined) 
		? <a {...attributes }>{children}</a>
		: createElement(as, attributes, children)
}